module.exports = __webpack_public_path__ + "static/healthcare-3450593b6adb2906bf02f914c4a5776c.png";